import React, { Component } from "react";
import logo from "./../../assets/images/logo.png";

class Header extends Component {
  render() {
    return (
      <div className="center-align">
        <h5 style={{ marginTop: "2rem" }}>
          Bienvenido a
        </h5>
        <img src={logo} alt="" style={{ width: "180px" }} />
      </div>
    );
  }
}

export default Header;
